import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { bem, canUseDom } from '@argos/utils'
import classnames from 'classnames'

import { SocketCreators, ChatCreators, ControlsCreators, FrameCreators } from '../actions'
import { Header } from '../components'
import { Controls, Messages } from '../containers'

import config from '../Core/Config'

const cn = bem({ prefix: 'lc-', block: 'window' })

class Window extends React.Component {
  static propTypes = {
    /* props passed via host app */
    brand: PropTypes.string,
    department: PropTypes.string,
    webSocketUrl: PropTypes.string,

    /* props injected via redux state */
    activeControl: PropTypes.oneOf(['Messenger', 'ExitPrompt', 'Form', 'WaitingRoom']),
    windowIsMinimized: PropTypes.bool,
    socketConnected: PropTypes.bool,
    chatId: PropTypes.string,
  }

  state = {
    controlsRef: undefined,
  }

  componentDidMount() {
    const { startWebSocket, socketConnected, chatId, resetChatInfo, brand, department, webSocketUrl } = this.props

    this.disablePageScroll()

    // If not connected and no chat ID
    if (!socketConnected && !chatId) {
      resetChatInfo()
      startWebSocket({ brand, department, webSocketUrl })
    }
  }

  componentWillUnmount() {
    this.enablePageScroll()
  }

  isMobileView = () => canUseDom() && window.outerWidth < config.breakpoints.desktop

  disablePageScroll = () => {
    if (this.isMobileView()) {
      document.querySelector('body').classList.add('lc-disable-scroll')
    }
  }

  enablePageScroll = () => {
    if (canUseDom()) {
      document.querySelector('body').classList.remove('lc-disable-scroll')
    }
  }

  setRef = (ref) => {
    this.setState({ controlsRef: ref })
  }

  handleExit = () => {
    const { activeControl, onShowExitPrompt } = this.props
    if (activeControl !== 'ExitPrompt') {
      onShowExitPrompt()
    }
  }

  render() {
    const { activeControl, windowIsMinimized, onToggleMinimized } = this.props

    const className = classnames(cn(''), {
      [cn('', 'minimized')]: windowIsMinimized,
      [cn('', 'overlay')]: activeControl === 'ExitPrompt',
    })

    return (
      <div
        aria-live='assertive'
        role='log'
        aria-labelledby='chatHeading'
        className={className}
        data-test={className}
        data-active-form={activeControl}>
        <div className={cn('container')}>
          <Header
            windowIsMinimized={windowIsMinimized}
            onToggleMinimized={() => onToggleMinimized(!windowIsMinimized)}
            onShowExitPrompt={() => this.handleExit()}
          />

          <Messages controlsRef={this.state.controlsRef} />

          <Controls onUpdateRef={this.setRef} />
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state) => ({
  activeControl: state.Controls.activeControl,
  windowIsMinimized: state.Frame.windowIsMinimized,
  socketConnected: state.Socket.socketConnected,
  chatId: state.Chat.chatId,
})

const mapDispatchToProps = (dispatch) => ({
  onToggleMinimized: (toggled) => dispatch(FrameCreators.toggleMinimized(toggled)),
  onShowExitPrompt: () => dispatch(ControlsCreators.setActiveControl('ExitPrompt')),
  startWebSocket: ({ brand, department, webSocketUrl }) =>
    dispatch(SocketCreators.startWebSocket(brand, department, webSocketUrl)),
  resetChatInfo: () => dispatch(ChatCreators.resetChatInfo()),
})

export { Window }

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(Window)
